import { observer } from 'mobx-react';
import { USER_PERMISSIONS } from 'src/constants/user';
import { sidebarStore } from 'src/mobx/sidebarStore';
import { hasPermissions } from 'src/utils/helpers';
import Indicator from 'src/view/components/Controls/Indicator/Indicator';
import { liveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';
import './style.scss';

const OrdersIndicator: React.FC = observer((): JSX.Element | null => {
  return liveOrdersStore.notViewedOrdersExists && hasPermissions(USER_PERMISSIONS.ORDERS_MANAGMENT) ? (
    <Indicator
      className={`order-indicator animate__faster animate__animated animate__fadeInLeft ${!sidebarStore.isOpen ? 'order-indicator_menu-close' : ''}`}
    />
  ) : null;
});

export default OrdersIndicator;
